<div class="love-button" [class.disabled]="!enabled" (mouseover)="onHover()" (mouseleave)="onLeave()">
    <app-icon-heart [size]='22' [color]="heartColor" (click)="love()" *ngIf="!loved"></app-icon-heart>
    <app-icon-heart-full [size]='22' color="rgb(249, 70, 120)" (click)="unlove()" *ngIf="loved"></app-icon-heart-full>
    <span>
        {{counter}}
    </span>
</div>
